import { Injectable } from '@angular/core';
import { DeviceService } from '@core/services/util/device.service';
import { environment } from '@environment';

@Injectable({
	providedIn: 'root'
})

export class ImageUrlCreatorService {

	constructor(
		private device: DeviceService
	) { }

	getMembershipImage(member: any) {
		const {id, active} = member;
		const idUrl = id + (active ? '' : '_disabled');
		const resolution = this.device.getResolution();
		const pictureShape = 'rectangle-19x10';
		return this._getImageUrl(pictureShape, resolution, 'brand', idUrl);
	}

	getCategoryImage(category: any, page: string, isThreeTileLayout?: boolean) {

		const resolution: string = this.device.getResolution();

		if (resolution === 'web') {
			return this._getImageUrl('square', resolution, 'category', category.id);
		}

		let picture_shape = (page === 'landing' && !isThreeTileLayout) ? 'square-v3' : (category.shape === 'square' ? 'square-v2' : 'horizontal-rectangle-v2');

		return this._getImageUrl(picture_shape, resolution, 'category', category.id);
	}


	getProductImage(product_id: number, layout: string) {

		const resolution: string = this.device.getResolution('product');

		let imageShape;

		switch (layout) {
			case 'square-image-layout':
				imageShape = 'square';
				break;

			default:
				imageShape = 'rectangle-19x10';
				break;
		}

		return this._getImageUrl(imageShape, resolution, 'product', product_id);
	}

	private _getImageUrl(shape, resolution, type, id) {
		return `${environment.assetsUrl}/${shape}/${resolution}/${type}/${id}`;
	}
}
